import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
} from '@fluentui/react-components';
import {
  Delete20Regular,
  Edit20Regular,
  MoreHorizontal20Regular,
} from '@fluentui/react-icons';

/**
 * Composant label pour le nœud Open Hours
 */
const OpenHoursNodeLabel = ({ callFlowData, handleEditNode, handleDeleteNode }) => {
  const { t } = useTranslation();
  const openHoursData = callFlowData?.deskOpen?.openHours || {};
  
  // Compter le nombre de jours avec des heures configurées
  const daysWithHours = Object.keys(openHoursData).filter(key => {
    const dayRanges = openHoursData[key];
    return Array.isArray(dayRanges) && dayRanges.length > 0;
  }).length;

  return (
    <div className="node-open-hours">
      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <button
            className="node-menu-btn"
            onClick={(e) => e.stopPropagation()}
            title="Options"
          >
            <MoreHorizontal20Regular />
          </button>
        </MenuTrigger>
        <MenuPopover>
          <MenuList>
            <MenuItem
              onClick={(e) => {
                e.stopPropagation();
                handleEditNode('open-hours');
              }}
            >
              {t('EDIT')}
            </MenuItem>
            <MenuItem
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteNode('open-hours');
              }}
            >
              {t('DELETE')}
            </MenuItem>
          </MenuList>
        </MenuPopover>
      </Menu>
      <div className="node-title">{t('OPEN_HOURS')}</div>
      <div className="node-separator"></div>
      <div className="node-info">
        <div className="node-info-item">
          {daysWithHours} {t('DAYS_CONFIGURED', { count: daysWithHours })}
        </div>
      </div>
    </div>
  );
};

export default OpenHoursNodeLabel;
